<template>
  <div
    v-if="membershipId"
    class="key-owner-avatar"
  >
    <TeamMemberAvatar
      :id="membershipId"
      class="key-owner-avatar__avatar"
      :size="35"
    />
    <span class="key-owner-avatar__label">
      {{ membershipStore.memberNameById[membershipId] }}
    </span>
  </div>
</template>

<script lang="ts">
export default {
  name: 'KeyOwnerAvatar',
}
</script>

<script lang="ts" setup>
import { computed } from 'vue'

import TeamMemberAvatar from '@/modules/Teams/TeamMemberAvatar.vue'

import type { ApiKeyPayload } from './types'
import { useMembershipStore } from '@/modules/Teams/useMembershipStore'

const membershipStore = useMembershipStore()

const props = defineProps<{ apiKey: ApiKeyPayload }>()

const membershipId = computed(() => membershipStore.memberIdByUserId[props.apiKey.user_id])
</script>

<style lang="scss" scoped>
.key-owner-avatar {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;

  &__avatar {
    cursor: pointer;
    user-select: none;
    height: 35px;
    width: 35px;
  }

  &__label {
    color: $colorContentSecondary;
    @include typographyRegularBody200;
  }
}
</style>
